export default function buildPostFilterElement({
    apiEndpoint,
    apiTools
}) {
    return async function postFilterElement(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }/element` 
        })
       
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(args.body)
        });
        return await res.json();
    }
}